module.exports = __webpack_public_path__ + "static/media/marcas (2).bce9e703.jpg";